import { useEffect } from 'react';

import { useGetList } from 'react-admin';
import { useFormContext, useWatch } from 'react-hook-form';
import { useFilterContext } from 'shared/mui/Filter/context/filterContext';
import { ExpenseSubarticles } from 'types/embedded/expenseReport';
import { cleanEmpty } from 'utils/cleanEmpty';

export const useExpenseSubarticlesFilter = () => {
  const { control, setValue, getValues } = useFormContext();
  const { setAppliedFilter } = useFilterContext();

  const expenseTypes: string[] | undefined = useWatch({ control, name: 'expenseTypes' });
  const expenseArticles: string[] | undefined = useWatch({ control, name: 'expenseArticles' });

  const expenseSubarticlesFilter = cleanEmpty({ expenseTypes, expenseArticles });

  // @ts-ignore
  const { data: availableExpenseSubarticles } = useGetList<ExpenseSubarticles>(
    'expense_subarticles',
    {
      filter: expenseSubarticlesFilter,
      pagination: { page: 1, perPage: 100 },
      sort: { field: 'id', order: 'ASC' },
    },
  );

  useEffect(() => {
    if (!availableExpenseSubarticles) {
      return;
    }

    const availableIds = availableExpenseSubarticles.map((subArticle) => subArticle?.['@id']);
    const selected: string[] = getValues('expenseSubarticles') || [];
    const filtered = selected.filter((id) => availableIds.includes(id));

    if (filtered.length !== selected.length) {
      setValue('expenseSubarticles', filtered, { shouldDirty: true });
      setAppliedFilter('expenseSubarticles', filtered);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [availableExpenseSubarticles]);

  return { expenseSubarticlesFilter };
};
